const autoNgTemplateLoaderTemplate1 = require('./save-auth-settings-button.html');

export const saveAuthSettingsButton = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  bindings: {
    onSaveSettings: '<',
    saveButtonDisabled: '<',
    saveButtonState: '<',
    limitedFeatureId: '<',
    limitedFeatureClass: '<',
    className: '<',
  },
};
